import { shallowRef } from 'vue'

// Store for all table selections, keyed by selectedRowKey
const selections = new Map()

/**
 * Composable for managing table row selections
 * @param {string} key - The unique key for this table's selection
 * @returns {Object} - Object containing selection ref and utility methods
 */
export function useTableSelection (key) {
  // Initialize selection for this key if it doesn't exist
  if (!selections.has(key)) {
    selections.set(key, shallowRef([]))
  }

  const selection = selections.get(key)

  const clearSelection = () => {
    selection.value = []
  }

  const setSelection = (value) => {
    selection.value = value
  }

  return {
    selection,
    clearSelection,
    setSelection
  }
}
